import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { CountryRepositoryBase } from '@skylab-shared/business';
export { CountryRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(CountryRepositoryBase)
export class CountryRepository {
    public constructor(
        http: Http,
        weaver: Weaver
    ) { }
}
